import React from 'react';
import { SectionProps } from '../types';
import classnames from 'classnames';
import { CheckSquareFilled, ClockCircleOutlined, ExportOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Stringable } from '../../../../services/utils/Stringable';
import { SidebarSectionEnum } from '../enums';

const Reservations = ({ data, ...rest }: SectionProps) => {
  const isReservationAvailable = data.has_reservations;
  const isRestaurantReservationAvailable = data.has_internal_reservations || data.has_reservations;
  const totalSeats = data.reservation_total_seats;
  const internalReservationAvailabilityLabel = isRestaurantReservationAvailable ? 'Yes' : 'No';

  return (
    <section {...rest} id={SidebarSectionEnum.Reservations}>
      <h4 className="text-md font-semibold text-slate-700 items-center">
        <ClockCircleOutlined className="mr-2 size-4" />
        Reservations
      </h4>
      <div className="flex justify-between text-slate-600 items-center">
        <p className="text-sm">Restaurant reservations</p>
        <p
          className={classnames('text-sm font-medium', {
            'px-[10px] py-[2px] bg-green-500/10 rounded-lg text-green-500 hover:bg-slate-700/80':
              isRestaurantReservationAvailable,
          })}
        >
          {isRestaurantReservationAvailable && <CheckSquareFilled className="mr-1" />}
          {internalReservationAvailabilityLabel}
        </p>
      </div>
      {!isReservationAvailable && data.has_internal_reservations && (
        <p className="text-xs text-slate-600 bg-gray-200/30 p-3 rounded-lg items-center">
          Not available online, reservations only by phone or email
        </p>
      )}
      {Boolean(data.links.reservation) && (
        <div className="flex justify-between text-slate-600 items-center">
          <p className="text-sm">Online reservations</p>
          <Button
            className="text-xs font-medium bg-slate-700/5 rounded-full"
            onClick={() =>
              window.open(
                new Stringable(data.links.reservation).start('https://').toString(),
                '_blank',
                'noopener noreferrer',
              )
            }
          >
            Via foodamigos
            <ExportOutlined className="size-3 ml-2" />
          </Button>
        </div>
      )}
      {isReservationAvailable && !!totalSeats && (
        <div className="flex justify-between text-slate-600 items-center">
          <p className="text-sm">Total seats</p>
          <p className="text-sm font-medium">{totalSeats}</p>
        </div>
      )}
    </section>
  );
};

export default Reservations;
